import React, {Component} from "react";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import MachineRentalForm from "./MachineRentalForm";
import * as machineRentalActions
    from "../../actions/machine-rental/machineRentalActions";
import FormDataFormatter from "../../services/FormDataFormatter";
import WithResolvedPromises from "../common/WithResolvedPromises";
import Placeholder from "../Placeholder";
import PlaceholderError from "../common/PlaceholderError";
import * as rentMachineCategoriesActions from "../../actions/rent-machine/rentMachineCategoryActions";
import PropTypes from "prop-types";
import * as submitButtonActions from "../../actions/submit/submitButtonActions";
import {toastr} from "react-redux-toastr";
import {messages} from "../common/Translations";
import {FormattedMessage, injectIntl} from "react-intl";
import ResetFormModal from "../ResetFormModal";
import * as modalActions from "../../actions/common/modalActions";
import ParkMachineForm from "../park-machine/park-machine/ParkMachineForm";


class MachineRentalFormContainer extends Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
        this.actions = this.getRequiredActions();
        this.handleReset = this.handleReset.bind(this);
    }

    getRequiredActions() {
        return [
            this.props.actions.getRentMachineCategories(),
        ]
    }

    submit(formFields) {
        this.props.actions.showSubmitButtonSpinner();
        // console.log(this.props.actions);
        this.props.actions.createMachineRent(FormDataFormatter.getFormData({...formFields}))
            .then(() => {
                this.props.actions.hideSubmitButtonSpinner();
                this.redirect();
                this.props.actions.resetMachineRent();
                toastr.success("Maskinleje oprettet");
            }).catch(() =>  this.props.actions.hideSubmitButtonSpinner());
    }

    redirect() {
        this.context.router.history.push('/rent');
    }

    confirmReset() {
        this.props.actions.hideResetFormModal();
        this.redirect();
    }

    handleReset() {
        this.props.actions.showResetFormModal();
    }

    render() {
        return (
            <WithResolvedPromises
                preloaderComponent={Placeholder}
                promises={this.actions}
                errorComponent={PlaceholderError}
            >
                <div className="card m-b-20">
                    <div className="card-block">
                        <h1 className="mb-3">Opret maskine til udlejning</h1>
                        <MachineRentalForm
                            initialValues={this.props.rentMachine}
                            onSubmit={this.submit}
                            isUpdate={false}
                            categories={this.props.categories}
                            handleReset={this.handleReset}
                        />
                    </div>
                    <ResetFormModal
                        modalTitle={this.props.intl.formatMessage(messages.resetModalTitle)}
                        modalContent={
                            <p>
                                <FormattedMessage
                                    id="reset.modal.message"
                                    defaultMessage="Are you sure, you want to cancel? All of your alterations will be lost."
                                />
                            </p>}
                        confirmText={this.props.intl.formatMessage(messages.buttonYes)}
                        closeText={this.props.intl.formatMessage(messages.buttonNo)}
                        handleConfirm={() => {this.confirmReset()}}
                    />
                </div>
            </WithResolvedPromises>
        );
    }
}

MachineRentalFormContainer.contextTypes = {
    router: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
    return {
        categories: state.rentMachineCategories,
        rentMachine: state.rentMachine
    };
}

function mapDispatchToProps(dispatch) {

    return {
        actions: bindActionCreators({
            ...rentMachineCategoriesActions,
            ...machineRentalActions,
            ...submitButtonActions,
            ...modalActions,
        }, dispatch)
    };
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(MachineRentalFormContainer));



// WEBPACK FOOTER //
// ./web/src/components/machine-rental/MachineRentalFormContainer.jsx